import React from "react";
import { useState, useEffect } from "react";

import { Form, Button, Col, Row, Spinner, Container } from "react-bootstrap";
import Cookies from "js-cookie";

import { getRequest, postRequest } from "../../api/axiosRequests";
import { PALETTE } from "../../common/ThemeConstants";

export default function UserSubscription({ user }) {
  const [showDeleteForm, setShowDeleteForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [userSubscription, setUserSubscription] = useState({ id: -1 });
  const [subscriptions, setSubscriptions] = useState([]);
  const [selectedSubscription, setSelectedSubscription] = useState(-1);
  const [isEditing, setIsEditing] = useState(false);

  async function fetchData() {
    const headers = { Authorization: localStorage.getItem("jwt") };
    const promise1 = getRequest(`currentUserSubscription/${user.id}`, headers);
    const promise2 = getRequest("subscriptions/", headers);
    Promise.all([promise1, promise2])
      .then((values) => {
        let userSubscription = values[0].data;
        const subscriptionList = values[1].data;
        const userSub = subscriptionList.filter(
          (s) => s.id === userSubscription.subscription
        );
        if (userSubscription.id != -1) {
          userSubscription.subscription = userSub[0];
          userSubscription.expire_at = new Date(
            userSubscription.expire_at.slice(0, 10)
          )
            .toISOString()
            .split("T")[0];
        }
        setUserSubscription(userSubscription);
        setSubscriptions(subscriptionList);
      })
      .catch((errs) => {
        setUserSubscription({ id: -1 });
        setSubscriptions([]);
      });
  }

  async function userSubscriptionPostRequest(data) {
    const csrftoken = Cookies.get("csrftoken");
    const headers = {
      "X-CSRFToken": csrftoken,
      Authorization: localStorage.getItem("jwt"),
    };
    const response = await postRequest("userSubscription/", data, headers);
    return response;
  }

  const handleSubmitUpdate = (event) => {
    event.preventDefault();
    if (userSubscription.id == -1) {
      return;
    }
    setIsLoading(true);
    const data = {
      id: userSubscription.id,
      user: user.id,
      subscription: userSubscription.subscription.id,
      expire_at: userSubscription.expire_at,
      start_at: userSubscription.start_at,
    };
    userSubscriptionPostRequest(data)
      .then((res) => {
        fetchData();
        setIsLoading(false);
        setIsEditing(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const handleSubmitSave = (event) => {
    event.preventDefault();
    if (selectedSubscription == -1) {
      return;
    }
    setIsLoading(true);
    const data = {
      id: userSubscription.id,
      user: user.id,
      subscription: selectedSubscription,
      expire_at: userSubscription.id != -1 ? userSubscription.expire_at : null,
      start_at: userSubscription.id != -1 ? userSubscription.start_at : null,
    };
    userSubscriptionPostRequest(data)
      .then((res) => {
        fetchData();
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const cancelUpdate = () => {
    fetchData();
    setIsEditing(false);
  };

  return (
    <div className="p-1">
      <Container
        className="rounded py-1"
        style={{ backgroundColor: PALETTE.LIGHTGRAY }}
      >
        <Row className="text-start pt-2" style={{ color: PALETTE.DARKGRAY }}>
          <p className="mb-1">Subscription:</p>
        </Row>
        <Row className="d-flex flex-nowrap overflow-auto mx-2">
          {userSubscription.id == -1 && (
            <Col className="ml-2" style={{ maxWidth: "fit-content" }}>
              <Form
                style={{ width: "175px", height: "175px", maxWidth: "100%" }}
                className="p-2 border rounded my-1"
                onSubmit={handleSubmitSave}
                action="/private/adminUsers"
              >
                <div>
                  <div className="m-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Add subscription</Form.Label>
                      <Form.Select
                        aria-label="type"
                        onChange={(event) =>
                          setSelectedSubscription(event.target.value)
                        }
                        value={selectedSubscription}
                      >
                        <option key={0} value={-1}></option>
                        {subscriptions.map((s) => (
                          <option key={s.id} value={s.id}>
                            {s.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </div>
                </div>
                <Button
                  className="mt-3"
                  style={{ width: "100%" }}
                  variant="dark"
                  type="submit"
                  disabled={isLoading}
                >
                  {isLoading && <Spinner animation="border" />}
                  {!isLoading && "Save"}
                </Button>
              </Form>
            </Col>
          )}
          {userSubscription.id != -1 && (
            <Col
              key={userSubscription.id}
              className="ml-2"
              style={{ maxWidth: "fit-content" }}
            >
              <Form
                style={{
                  width: "250px",
                  height: "fit-content",
                  maxWidth: "100%",
                }}
                className="p-2 border rounded my-1"
                onSubmit={handleSubmitUpdate}
                action="/private/adminUsers"
              >
                <div className="text-start t-1">
                  <Form.Group className="mb-3">
                    <Form.Label>
                      {userSubscription.subscription.name}
                    </Form.Label>
                    <Row>
                      <Col xs={4} className="align-self-center">
                        <span>Expires:</span>
                      </Col>
                      <Col xs={8}>
                        <Form.Control
                          disabled={!isEditing}
                          type="date"
                          aria-label="expire_at"
                          onChange={(event) =>
                            setUserSubscription({
                              ...userSubscription,
                              expire_at: event.target.value,
                            })
                          }
                          value={userSubscription.expire_at}
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                </div>
                {isEditing && (
                  <>
                    <Button
                      size="sm"
                      className="mt-2"
                      style={{
                        width: "100%",
                        border: `1px solid ${PALETTE.RED}`,
                        backgroundColor: PALETTE.RED,
                      }}
                      onClick={() => {
                        cancelUpdate();
                      }}
                      disabled={isLoading}
                    >
                      Cancel
                    </Button>
                    <Button
                      size="sm"
                      className="mt-1"
                      style={{ width: "100%" }}
                      variant="dark"
                      type="submit"
                      disabled={isLoading}
                    >
                      {isLoading && <Spinner animation="border" />}
                      {!isLoading && "Save"}
                    </Button>
                  </>
                )}
                {!isEditing && (
                  <Button
                    className="mt-3"
                    style={{ width: "100%" }}
                    variant="dark"
                    onClick={() => setIsEditing(true)}
                  >
                    {" "}
                    Edit{" "}
                  </Button>
                )}
              </Form>
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
}
